import { render, staticRenderFns } from "./ModalAddPackage.vue?vue&type=template&id=3a0ac2e5"
import script from "./ModalAddPackage.vue?vue&type=script&lang=js"
export * from "./ModalAddPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports